module.exports = __webpack_public_path__ + "img/one-enabled.59ea1e17.svg";